// modules
import { createAction } from 'redux-actions'

// actions
export const setResponsibleList = createAction('SET_RESPONSIBLE_LIST')

export const setGoalList = createAction('SET_GOAL_LIST')
export const setGoalCategoryList = createAction('SET_GOAL_CATEGORY_LIST')

export const setInterventionList = createAction('SET_INTERVENTION_LIST')
export const setInterventionTypeList = createAction(
  'SET_INTERVENTION_TYPE_LIST'
)

export const setPatientGoalList = createAction('SET_PATIENT_GOAL_LIST')
export const setPatientGoalValue = createAction('SET_PATIENT_GOAL_VALUE')

export const setExpandedPatientInterventionList = createAction(
  'SET_EXPANDED_PATIENT_INTERVENTION_LIST'
)
export const setPatientInterventionValue = createAction(
  'SET_PATIENT_INTERVENTION_VALUE'
)

export const resetGoal = createAction('RESET_GOAL')

export const setModalPatientGoalList = createAction(
  'SET_MODAL_PATIENT_GOAL_LIST'
)
export const setAddActivityInterventionList = createAction(
  'SET_ADD_ACTIVITY_INTERVENTION_LIST'
)

export const setPatientBillingCodes = createAction('SET_PATIENT_BILLING_CODES')
export const setPatientCarePlanReviews = createAction(
  'SET_PATIENT_CARE_PLAN_REVIEWS'
)
export const setPatientCarePlanChangeLog = createAction(
  'SET_PATIENT_CARE_PLAN_CHANGE_LOG'
)

export const setPatientActiveCarePlanCount = createAction(
  'SET_PATIENT_ACTIVE_CARE_PLAN_COUNT'
)
